import { connectRouter, routerMiddleware } from 'connected-react-router';

import { createBrowserHistory } from 'history';
import {
  applyMiddleware, combineReducers, createStore, compose,
} from 'redux';
import { createResponsiveStateReducer, responsiveStoreEnhancer } from 'redux-responsive';
import createSagaMiddleware from 'redux-saga';

import { mainSaga } from 'store/modules/main-saga';
import { reducerApp } from 'store/modules/app/reducers';
import { debugReducer } from 'store/modules/debug/reducers';
import { signUpReducer } from 'store/modules/sign-up/reducers';
import { optionsReducer } from 'store/modules/options/reducers';
import { callbackRequestReducer } from 'store/modules/callback-request/reducers';
import { addressLookupReducer } from 'store/modules/address-lookup/reducers';
import { accountantLookupReducer } from 'store/modules/accountant-lookup/reducers';

export const history = createBrowserHistory();

// Need to account for the 0.02px as there's a rounding error in either
// the responsiveStateReducer package or the browsers.
const breakpoints = {
  small: '(max-width: 767.98px)',
  medium: '(min-width: 768px) and (max-width:1023.98px)',
  large: '(min-width: 1024px) and (max-width:1279.98px)',
  xLarge: '(min-width: 1280px) and (max-width:1599.98px)',
  xxLarge: '(min-width: 1600px)',
};

const rootReducer = combineReducers({
  browser: createResponsiveStateReducer(breakpoints),
  app: reducerApp,
  router: connectRouter(history),
  debug: debugReducer,
  signUpReducer,
  optionsReducer,
  callbackRequestReducer,
  addressLookupReducer,
  accountantLookupReducer,
});

export type IReducerState = ReturnType<typeof rootReducer>;

const sagaMiddleware = createSagaMiddleware({});

const middleware = [routerMiddleware(history), sagaMiddleware];

let composeEnhancers = compose;

if (process.env.REACT_APP_ENVIRONMENT !== 'production') {
  // eslint-disable-next-line no-underscore-dangle
  const composeWithDevToolsExtension = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;

  if (typeof composeWithDevToolsExtension === 'function') {
    composeEnhancers = composeWithDevToolsExtension;
  }
}

export const store = createStore(
  rootReducer,
  {},
  composeEnhancers(responsiveStoreEnhancer, applyMiddleware(...middleware)),
);

sagaMiddleware.run(mainSaga);
